<template>
  <div
    class="flex flex-wrap w-full"
  >
    <div class="flex flex-1 justify-center items-center">
      <div
        v-if="leftLine"
        ref="horizontal"
        :id="horizontalId"
        class="flex flex-1"
        style="min-height: 2px; background: #bac2cc"
      ></div>
    </div>
    <landing-step-point ref="stepPoint" :point-index="index" />
    <div class="flex flex-1 justify-center items-center">
      <div
        v-if="rightLine"
        ref="horizontal"
        :id="horizontalId"
        class="flex flex-1"
        style="min-height: 2px; background: #bac2cc"
      ></div>
    </div>
  </div>
</template>

<script>
import { LandingPageConstants } from './LandingPageConstants';

export default {
  name: 'HowItWorksHorizontal',
  mixins: [LandingPageConstants],

  props: {
    index: {
      type: Number,
      default: 0,
    },
    horizontalLinePosition: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      pointId: 'stepPoint_' + this.index,
      horizontalId: 'horizontal_' + this.index,
    };
  },

  computed: {
    leftLine() {
      return this.horizontalLinePosition === 'left';
    },

    rightLine() {
      return this.horizontalLinePosition === 'right';
    },
  },

  methods: {
    setColors(windowPresentYPos) {
      let stepPointRef = this.$refs['stepPoint'];
      const stepPointCenterPosition =
        stepPointRef.$el.offsetTop -
        this.VIRTUAL_DIFFERENCE_FOR_STEP_POINTS +
        this.STEP_POINT_RADIUS;
      const deltaY = stepPointCenterPosition - windowPresentYPos;
      const color = this.getRGB(this.colorLerp(deltaY));
      let horizontal = this.$refs['horizontal'];

      /**
       * recoloring stepPoint
       */
      stepPointRef.setColor(color);

      /**
       * recoloring horizontal line
       */
      if (horizontal) {
        horizontal.style.background = color;
      }
    },
  },
};
</script>
